import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import styled, { css } from 'styled-components';
import PersonalInfoWrapper from './ContentWrapper';

export const Childrens = styled.div`
  grid-row: 1/-1;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(60, 64, 67, 0.15);
  border-radius: 0.25rem;
  background-color: white;
`;
export const ContentCardWrapper = styled.div`
  justify-self: baseline;

  width: inherit;
  position: relative;
`;
export const ProfileIcon = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: inherit;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
`;

export const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */

  height: -webkit-fill-available;

  width: 100%;
  width: -moz-available; /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  width: fill-available;

  height: 100%;
  height: -moz-available; /* WebKit-based browsers will ignore this. */
  height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  height: fill-available;

  .featherLine {
    color: ${(props) => props.isUploading && 'white'};
  }
  @supports (-moz-appearance: none) {
    width: 100%;
    height: 100%;
  }
`;

export const Image = styled.img`
  width: inherit;
  height: inherit;
  object-fit: cover;

  opacity: ${(props) => props.isUploading && '0.5'};
`;

export const IconWrapper = styled.span``;

export const EditWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
  width: 16px;
  height: 16px;
  margin: 4px 4px 0 0;
  pointer-events: auto;
  cursor: pointer;
  z-index: 1;
  background: rgba(71, 56, 128, 0.2);
  border-radius: 2px;
  user-select: none;
  -webkit-user-select: none;

  ${({ createListing }) => {
    if (createListing) {
      return css`
        width: 12px;
        height: 12px;
      `;
    }
    return css``;
  }}

  /**
  * Beacuse parent span is absolute and child dropdown is absolute
  * we need to assign the values manually
  * rather calculating programatically the position of parent element
  */
  .profileOpts {
    left: 25px;
    top: 0;
  }

  /**
  * 
  */
  .profileOptsMenu {
    width: max-content;
    li,
    label {
      display: flex;
      align-items: center;
      font-size: 12px;
      line-height: 14px;
      padding: 0;
    }
    li {
      padding: 4px 6px;
    }
  }
`;

export const FileUploadWrapper = styled.input`
  display: none;
`;

export const LoaderWrapper = styled.span`
  position: absolute;
`;

const PersonalInfo = (props) => {
  const { children, userPreferences } = props;
  const {
    layout: { previewPad },
  } = userPreferences;

  return (
    <PersonalInfoWrapper previewPad={previewPad}>
      <ContentCardWrapper>{children}</ContentCardWrapper>
    </PersonalInfoWrapper>
  );
};

PersonalInfo.propTypes = {
  children: propTypes.node.isRequired,
  userPreferences: propTypes.objectOf(propTypes.object).isRequired,
};

const mapStateToProps = (state) => ({
  userPreferences: state.editResumeFormReducer.userPreferences,
});

export default connect(mapStateToProps)(PersonalInfo);
